import { Heart } from 'lucide-react';

interface HeartFavoriteProps {
  active: boolean;
  onClick?: () => void;
  size?: 'sm' | 'md' | 'lg';
  ariaLabel?: string;
}

// Hjärt-knapp som togglas mellan tom (vit/grå outline) och aktiv (röd fill).
export function HeartFavorite({
  active,
  onClick,
  size = 'md',
  ariaLabel = 'Favorite',
}: HeartFavoriteProps) {
  const interactive = !!onClick;
  const px =
    size === 'lg' ? 'w-6 h-6' : size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  const minTouch =
    size === 'lg'
      ? 'min-w-[44px] min-h-[44px]'
      : 'min-w-[32px] min-h-[32px]';

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!interactive}
      aria-label={ariaLabel}
      aria-pressed={active}
      className={`${minTouch} flex items-center justify-center transition-transform ${
        interactive ? 'cursor-pointer hover:scale-110 active:scale-95' : 'cursor-default'
      }`}
    >
      <Heart
        className={`${px} ${
          active ? 'fill-heart text-heart' : 'text-loupe-text-3'
        }`}
        strokeWidth={1.8}
      />
    </button>
  );
}
